// extracted by mini-css-extract-plugin
export default {"Layout":"LayoutDark_Layout__R147s"};